import { EmailInUseError, UnexpectedError } from "../../../domain/errors";
import { ChangeUserDetails } from "../../../domain/usecases";
import { HttpClient, HttpStatusCode } from "../../protocols/http";

export class RemoteChangeUserDetails implements ChangeUserDetails {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<void>
  ) {}

  async execute(params: ChangeUserDetails.Params): Promise<void> {
    console.log("ChangeUserDetails", params);
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body!;
      case HttpStatusCode.forbidden:
        throw new EmailInUseError();
      default:
        throw new UnexpectedError();
    }
  }
}

// export namespace RemoteAddAccount {
//   export type Model = ChangeUserDetails.Model;
// }
